import { render, staticRenderFns } from "./KnowledgeBase.vue?vue&type=template&id=19b4df40"
import script from "./KnowledgeBase.vue?vue&type=script&lang=js"
export * from "./KnowledgeBase.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports